export default "__VITE_ASSET__Cfy6Pryr__"